import React, { useRef, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

const NotFound = () => {
    return (
        <React.Fragment>
            <Grid
                container
                justifyContent="center"
                sx={{
                    background: "#ffe4c5",
                    pb: 5,
                }}
            >
                <img alt="icon" src="/images/Top/Error.png" width="10%" />
                <Typography variant="h4" gutterBottom component="div">
                    {"お探しのページが見つかりませんでした。"}
                </Typography>
            </Grid>
            <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ mb: 3 }}>
                {"ページが移動または削除された可能性があります。"}
                <br/>
                {"URLが正しいかご確認の上、再度お試しください。"}
            </Grid>
            <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ mb: 3 }}>
                <Button variant="contained" href="/" fullWidth sx={{ maxWidth: "30rem", lineHeight:"2.75", color: "white", fontWeight: "bold" }}>
                    トップページへ戻る
                </Button>
            </Grid>
        </React.Fragment>
    );
};

export default NotFound;
